// Attachment API
import {
    RequestConfigFunction,
} from 'app/types/request.types'

import AttachmentType from 'app/shared-components/Attachment/Attachment.types'

type AttachmentRequests = {
    create: RequestConfigFunction<{data: Record<string, any>}>,
    get: RequestConfigFunction<{id: number}>,
    filterRequest: RequestConfigFunction<{ ids?: AttachmentType[] | number[] }>,
}

const attachmentRequests: AttachmentRequests = {
    create: ({
        data,
    }) => {
        return {
            url: 'attachment',
            method: 'POST',
            data,
            headers: {
                'Content-Type': `multipart/form-data; boundary=${data._boundary}`, // eslint-disable-line no-underscore-dangle
            },
        }
    },
    get: ({
        id,
    }) => {
        return {
            url: `attachment/${id}`,
            method: 'GET',
        }
    },
    filterRequest: ({
        ids,
    }: {
        ids?: AttachmentType[] | number[],
    }) => {
        return {
            url: 'attachment/filter-request/all',
            method: 'POST',
            data: {
                ...(ids && {
                    includeFilters: {
                        id: ids,
                    },
                }),
            },
        }
    },
}

export default attachmentRequests
